import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdvancedFilterValue } from '../../models/advancedFilters';
import { ReviewDecision } from '../../models/predictions';
import { RootState } from '../store';

interface PredictionFilterState {
  activeTags: AdvancedFilterValue[];
  is_reviewed?: boolean;
  review_decision?: ReviewDecision;
  has_corresponding_label?: boolean;
  features?: AdvancedFilterValue[];
  datasource?: AdvancedFilterValue;
  dicom_icid?: string;
  dicom_fid?: string;
  source_uuid?: string;
  study_fid?: string;
  study_icid?: string;
  created_at_after?: string;
  created_at_before?: string;
  label_created_at_after?: string;
  label_created_at_before?: string;
}

const initialState: PredictionFilterState = {
  activeTags: [],
  is_reviewed: undefined,
  review_decision: undefined,
  has_corresponding_label: undefined,
  features: undefined,
  datasource: undefined,
  dicom_icid: undefined,
  dicom_fid: undefined,
  source_uuid: undefined,
  study_fid: undefined,
  study_icid: undefined,
  created_at_after: undefined,
  created_at_before: undefined,
  label_created_at_after: undefined,
  label_created_at_before: undefined,
};

const predictionFilterSlice = createSlice({
  name: 'predictionFilter',
  initialState,
  reducers: {
    setPredictionFilter: (
      state,
      action: PayloadAction<{
        key: keyof Omit<PredictionFilterState, 'activeTags'>;
        value: any;
      }>
    ) => {
      const { key, value } = action.payload;
      (state as any)[key] = value;
    },
    resetFilters: state => {
      state.activeTags = [];
      state.is_reviewed = undefined;
      state.review_decision = undefined;
      state.has_corresponding_label = undefined;
      state.features = undefined;
      state.datasource = undefined;
      state.dicom_icid = undefined;
      state.source_uuid = undefined;
      state.study_icid = undefined;
      state.created_at_after = undefined;
      state.created_at_before = undefined;
      state.label_created_at_after = undefined;
      state.label_created_at_before = undefined;
    },
    updateActiveTags: (state, action: PayloadAction<AdvancedFilterValue[]>) => {
      state.activeTags = action.payload;
    },
  },
});

export const { setPredictionFilter, resetFilters, updateActiveTags } =
  predictionFilterSlice.actions;

export const selectPredictionFilterState = (state: RootState) => state.predictionFilter;
export const selectPredictionActiveFilters = (state: RootState) =>
  state.predictionFilter.activeTags;

export default predictionFilterSlice.reducer;
